var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.mediaQueryComponent,
    _vm._b(
      { tag: "component", attrs: { facets: _vm.facets } },
      "component",
      _vm.$attrs,
      false
    ),
    [
      _vm._l(_vm.slots, function(slot) {
        return [
          _vm._t(
            _vm.getSlotName(slot),
            [
              _vm._v(
                "\n            " + _vm._s(_vm.getSlotName(slot)) + "\n        "
              )
            ],
            { slot: slot }
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4779c7ed", { render: render, staticRenderFns: staticRenderFns })
  }
}